import { useDateSegment } from "@react-aria/datepicker";
import {
  type DateFieldState,
  type DateSegment as DateSegmentType,
  type TimeFieldState,
} from "@react-stately/datepicker";
import { useRef } from "react";

type DateSegmentProps = {
  segment: DateSegmentType;
  state: TimeFieldState | DateFieldState;
};

const DateSegment = ({ segment, state }: DateSegmentProps) => {
  const ref = useRef(null);
  const { segmentProps } = useDateSegment(segment, state, ref);

  return (
    <span
      {...segmentProps}
      data-type={segment.type}
      className="inline rounded p-0.5 caret-transparent outline-hidden focus:bg-neutral-95 focus:text-neutral-10 data-placeholder:text-neutral-70 focus:data-placeholder:text-neutral-10 data-[type=literal]:px-0 data-[type=literal]:text-neutral-70"
      ref={ref}
    >
      {segment.text}
    </span>
  );
};

export default DateSegment;
